export default __webpack_public_path__ + "static/media/TUNE_card.fd820143.png";